module.exports = __webpack_public_path__ + "static/media/zapsplat_household_antique_larder_door_creak_002_19471.3f01b78a.wav";